import { render, staticRenderFns } from "./OperaGoodsOrderDetail.vue?vue&type=template&id=62980df4&scoped=true&"
import script from "./OperaGoodsOrderDetail.vue?vue&type=script&lang=js&"
export * from "./OperaGoodsOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./OperaGoodsOrderDetail.vue?vue&type=style&index=0&id=62980df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62980df4",
  null
  
)

export default component.exports